import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-mensagem',
  templateUrl: './mensagem.component.html',
  styleUrls: ['./mensagem.component.scss']
})
export class MensagemComponent {
  @Input() usuario: string;
  @Input() mensagemUsuario: string;
  // TODO: conferir qual é o tipo da imagem inserida
  @Input() imagemInserida: any;
  @Input() showOrHideImage: boolean = true;
}
